import React, { useEffect, useState } from 'react'
import { format } from 'date-fns'

import CustomButton from '../../UI/Buttons/CustomButton'
import Checkbox from '../../UI/Inputs/Checkbox'

import { useDispatch, useSelector } from '../../../store'
import { setIsShowLabelsAction, setIsShowPopupAction } from '../../../store/application/slice'
import Label from '../../UI/Icons/Label'

import './CalendarToolbar.scss'
import { addDays } from '@fullcalendar/core'
import { CALENDAT_VIEW } from '../../../store/application/types'
import { useLocation, useHistory } from 'react-router';

const HeaderToolbar = ({ calendarApi, disableFilters, checkedDate }: any) => {
  const [, updateState] = useState<any>()
  const [date, setDate] = useState<any>(calendarApi?.currentDataManager?.state?.currentDate)
  const dispatch = useDispatch()
  const { isShowPopup, isShowLabels, calendarView } = useSelector((state) => ({
    isShowPopup: state.app.isShowPopup,
    isShowLabels: state.app.isShowLabels,
    calendarView: state.app.calendarView
  }))

  useEffect(() => {
    if (checkedDate && calendarApi) {
      calendarApi['gotoDate'](checkedDate)
    }
    setDate(calendarApi?.currentDataManager?.state?.currentDate)
  }, [calendarApi])

  const changeRange = (direction: string) => {
    calendarApi[direction]()
    updateState({})
  }

  const hideLabels = () => {
    dispatch(setIsShowLabelsAction())
  }

  const location = useLocation();

  useEffect(()=>{
    const date = new URLSearchParams(location.search).get('date')
    if (date && calendarApi && !checkedDate) {
      calendarApi['gotoDate'](date)
      setDate(calendarApi?.currentDataManager?.state?.currentDate)
    }
  },[location,calendarApi, checkedDate])

  

  return (
    <div className='calendar-toolbar'>
      {!disableFilters && (
        <div className='calendar-toolbar__absolute-container'>
          <div className='calendar-toolbar__absolute-container__show-preview'>
            <Checkbox
              type='checkbox'
              checked={isShowPopup}
              onChange={() => dispatch(setIsShowPopupAction(!isShowPopup))}
              label='Show Pop-Up Previews'
            />
          </div>
          <div
            className={`calendar-toolbar__absolute-container__bookmark ${isShowLabels && 'active'}`}
            onClick={hideLabels}
          >
            <Label />
          </div>
        </div>
      )}
      <div className='calendar-toolbar__calendar-navigation'>
        <CustomButton button='move' contentClass='arrow-left' onClick={() => changeRange('prev')} />
        <div className='calendar-toolbar__calendar-navigation__title'>
          {!calendarApi
            ? 'Month'
            : calendarView === CALENDAT_VIEW.MONTH_VIEW
            ? format(
                calendarApi.currentDataManager.state.currentDate || date || new Date(),
                'MMMM YYY'
              )
            : `${format(calendarApi.view.activeStart, 'MMM dd')} - 
              ${format(addDays(calendarApi.view.activeEnd, -1), 'MMM dd')}`}
        </div>
        <CustomButton
          button='move'
          contentClass='arrow-right'
          onClick={() => changeRange('next')}
        />
      </div>
    </div>
  )
}

export default HeaderToolbar
